@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.apply-preset-container {
  padding: 15px;
}

.loading-indicator {
  width: 100%;
  height: 83px;
}

.label {
  font-size: 13px;
}

.bulk-update-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;

  > div {
    margin-right: 10px;
  }
}

.buttons-footer {
  display: flex;
  justify-content: center;
}

.manage-presets-button {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid @orders-drawer--presets--border-color;
  border-radius: 3px;
  background: transparent;
  padding: 0;

  &:hover {
    border-top-color: @orders-drawer--presets--border-color;
  }

  > svg {
    fill: @orders-drawer--presets--fill-color;
    padding: 6px;
  }
}

.information-icon {
  padding: 8px 6px;
  margin-top: 1px;
}
